import GetInvolved from "../components/GetInvolved";
import Donate from "../components/Donate";

export default function GetInvolvedPage() {
  return (
    <div data-testid="get-involved-page">
      <GetInvolved />
      <Donate />
    </div>
  );
}
